import { formatCurrency } from 'utils';
import { formatPercent } from 'utils/formatters';
import { grey } from '@mui/material/colors';
import { Column } from 'components/shared/TableListing/types';
import { DealerProfitabilityListingEntity } from '../../../types';

const sharedCellStyles = {
  minHeight: 'auto',
  minWidth: '10rem',
  alignItems: 'flex-start',
};

const sharedHeaderStyles = {
  backgroundColor: grey[200],
};

export const DealerProfitabilityListingColumns: Column<DealerProfitabilityListingEntity>[] = [
  {
    header: 'Net Selling Price',
    renderKey: 'netSellingPrice',
    formatter: value => formatCurrency(value, true),
    headerStyles: sharedHeaderStyles,
    cellStyles: sharedCellStyles,
  },
  {
    header: 'Total Dealer Cost',
    renderKey: 'totalDealerCost',
    formatter: value => formatCurrency(value, true),
    headerStyles: sharedHeaderStyles,
    cellStyles: sharedCellStyles,
  },
  {
    header: 'Gross Profit',
    renderKey: 'grossProfit',
    formatter: value => formatCurrency(value, true),
    headerStyles: sharedHeaderStyles,
    cellStyles: sharedCellStyles,
  },
  {
    header: 'Over/Under Allowance Total',
    renderKey: 'overUnderAllowanceTotal',
    formatter: value => formatCurrency(value, true),
    headerStyles: sharedHeaderStyles,
    cellStyles: sharedCellStyles,
  },
  {
    header: 'Margin',
    renderKey: 'marginRate',
    formatter: value => formatPercent(value, 1),
    headerStyles: sharedHeaderStyles,
    cellStyles: sharedCellStyles,
  },
];
